import React from 'react'

import { getSrc } from 'gatsby-plugin-image'
import 'bootstrap/dist/css/bootstrap.min.css'
import './variables.scss'
import './global.scss'

import { useStaticQuery, graphql } from 'gatsby'
import Header from './header'
import Footer from './footer'

const Layout = (props) => {
  const { children } = props
  const { allContentfulSiteGlobals, siteBuildMetadata } = useStaticQuery(
    graphql`
      query SiteGlobalsQuery {
        allContentfulSiteGlobals(limit: 1, sort: {siteTitle: ASC}) {
          nodes {
            ... Header
            ... Footer
            siteBackground {
              gatsbyImageData(layout:FIXED)
            }
          }
        }
        siteBuildMetadata {
          buildTime
        }
      }`)
  const siteData = allContentfulSiteGlobals?.nodes[0]

  return (
    <>
      <img className="sitebg" src={getSrc(siteData.siteBackground)} alt={siteData.siteBackground.description} />
      <Header siteData={siteData} />
      <main>{children}</main>
      <Footer copyrightLine={siteData?.copyrightLine}
        content={siteData?.footerContent}
        navItems={siteData?.footerNavigation}
        buildTime={siteBuildMetadata.buildTime} />
      <script src="/js/bootstrap.min.js"></script>
    </>
  )
}

export default Layout